// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DatePicker__calendar .MuiPickersDay-daySelected,
.DatePicker__calendar .MuiPickersDay-daySelected:hover {
    background-color: var(--palette-trovit-blue);
}

.DatePicker__calendar .MuiPickersDay-current {
    color: var(--palette-trovit-blue);
}

.DatePicker__calendar .MuiPickersDay-daySelected::after {
    content: '';
}

.DatePicker__calendar .MuiPickersDay-daySelected:hover::after {
    position: absolute;
    top: -1px;
    left: -1px;
    bottom: -1px;
    right: -1px;
    border-radius: 10rem;
}

.DatePicker__calendar .MuiPickersDay-daySelected:hover:after {
    background: var(--palette-thribee-white);
    opacity: 0.08;
}

.Input__container.Input__container--underline.DatePicker__Input--error:after {
    transform: scaleX(0);
    border-bottom-color: var(--palette-gray-8);
}

.Input .Input__label.DatePicker__label--error {
    color: var(--palette-gray-8);
}

.Input .DatePicker__FormHelperText--error {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./js/components/library/mui4/input/DatePicker/DatePicker.css"],"names":[],"mappings":"AAAA;;IAEI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".DatePicker__calendar .MuiPickersDay-daySelected,\n.DatePicker__calendar .MuiPickersDay-daySelected:hover {\n    background-color: var(--palette-trovit-blue);\n}\n\n.DatePicker__calendar .MuiPickersDay-current {\n    color: var(--palette-trovit-blue);\n}\n\n.DatePicker__calendar .MuiPickersDay-daySelected::after {\n    content: '';\n}\n\n.DatePicker__calendar .MuiPickersDay-daySelected:hover::after {\n    position: absolute;\n    top: -1px;\n    left: -1px;\n    bottom: -1px;\n    right: -1px;\n    border-radius: 10rem;\n}\n\n.DatePicker__calendar .MuiPickersDay-daySelected:hover:after {\n    background: var(--palette-thribee-white);\n    opacity: 0.08;\n}\n\n.Input__container.Input__container--underline.DatePicker__Input--error:after {\n    transform: scaleX(0);\n    border-bottom-color: var(--palette-gray-8);\n}\n\n.Input .Input__label.DatePicker__label--error {\n    color: var(--palette-gray-8);\n}\n\n.Input .DatePicker__FormHelperText--error {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
